import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService';
import { executeTaggeo, setAddCardFormData, setUnificationFlow } from '../../../store/actions';
import CarouselMegasTelcel from '../../organisms/CarouselMegasTelcel';
import { CATEGORY_PLANS_ID_PAQUETE_POR_TIEMPO, SERVICE_ID_TELCEL_PLANES, SERVICE_ID_TELCEL_POSPAGO, SERVICE_ID_TELCEL_RECARGA } from '../../../constants';
import { 
	getTokenizationOnSelector, 
	getCanMultiAnalytics,
	getOriginParamsSelector 
} from '../../../store/selectors/paymentsSelectors';
import { getServicesTelcel } from '../../organisms/utils';
const PaymentMethodsList = (props) => {

	const [isLoadingForm, setIsLoadingForm] = React.useState(false);
	const [imgClaroPay, setImgClaroPay] = React.useState(`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}gr_fico_claro_pay_0_mb.png`);

	const handleContinue = () => {
		// Taggeo
		const payment_method = props.addCardFormData.paymentMethodSelected === "claro-pay"
			? "N2"
			: "Tarjeta";
		if(!props.isContainerTelcel) {
			props.executeTaggeo({
				step: "Formulario de pago",
				action: "Click modal " + payment_method,
				modal_id: "Elige método de pago"
			});
		}

		if (props.addCardFormData.paymentMethodSelected === "credit-card") {
			setIsLoadingForm(true);

			setTimeout(() => {
				props.setAddCardFormData({ ...props.addCardFormData, isOpenAddCardForm: true });
			}, 500);
		}

		if (props.addCardFormData.paymentMethodSelected === "claro-pay") {
			props.handleCloseSelectCardAnonimous();

			if (!props.isAnonimous) {
				setTimeout(() => {
					ClaroSDKService.openOnBoarding();
				}, 500);
			} else {
				if (!props.msisdn) {
					ClaroSDKService.openLogin();
				} else {
					props.handleOpenModalCardHE();
				}	
			}
					
		}		
	}

	React.useEffect(() => {
		setIsLoadingForm(false);
	}, [props.addCardFormData.isOpenAddCardForm]);

	React.useEffect(() => {
		if (props.planCategory && (props.planCategory === 4 || props.planCategory === 3)) {
			if (props.planBenefits && props.planBenefits === 200) {
				setImgClaroPay(`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}gr_fico_claro_pay_200_mb.png`)
			}
			if (props.planBenefits && props.planBenefits === 500) {
				setImgClaroPay(`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}gr_fico_claro_pay_500_mb.png`)
			}
		}
	}, [])

	React.useEffect(() => {

		if (props.isOpen) {
			setTimeout(() => {
				if(props.canMultiAnalytics && props.isContainerTelcel) {
					const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
					props.executeTaggeo({
							eventName: "pay_service_or_tae",
							seccion: "servicios",
							subseccion: getServicesTelcel(props.serviceInfo.serviceId),
							origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
							pantalla: "formulario de pago",
							nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ,
							tipoElemento: "modal",
							nombreElemento: "ahora elige tu metodo de pago",
							trackState: true,
							isTelcel: true,
					}, true);
				}  else {
					props.executeTaggeo({
						step: "Formulario de pago",
						action: "View modal",
						modal_id: "Elige método de pago"
					});
				}
			}, 500);			
		}
		
	}, [props.isOpen])

	React.useEffect(() => {
		if (props.addCardFormData.paymentMethodSelected) {
			handleContinue();
			props.setAddCardFormData({ ...props.addCardFormData, paymentMethodSelected: undefined })
		}
	}, [props.addCardFormData.paymentMethodSelected])

	return (
		<>
			{
				props.isContainerTelcel
					?
					<div style={{ overflow: 'scroll', height: "75vh", width:'100%', position: "relative" }}>
						<p style={{
							fontFamily: 'AMX-Regular',
							fontSize: '28px',
							color: '#222222',
							margin: '0px 0px 19px 0px',
							textAlign: 'center',
						}}>
							Ahora elige<br />
							tu método de pago
						</p>
			
						{/* Loading */}
						{
							isLoadingForm &&
							<div style={{
								height: "150px",
								width: "100%",
								background: "rgba(246,246,246,0.3)",
								position: "absolute",
								left: "0px",
								zIndex: "2",
								display: "flex",
								alignItems: "center",
								justifyContent: "center"
							}}>
								<img src='https://logosuat.claropay.com/ClaroPayLoading2.gif' width="45" height="45" />
							</div>
						}
			
						{
							1 === 1 &&
							(
								props.serviceId === SERVICE_ID_TELCEL_PLANES || 
								props.serviceId === SERVICE_ID_TELCEL_RECARGA ||
								props.serviceId === SERVICE_ID_TELCEL_POSPAGO
							) &&
							(
								!props.serviceInfo ||
								!props.serviceInfo.categoryPlansId ||
								parseInt(props.serviceInfo.categoryPlansId) !== parseInt(CATEGORY_PLANS_ID_PAQUETE_POR_TIEMPO)				
							)				
								?
									// Banner open Login/Oboarding
									<CarouselMegasTelcel 
										origin={"SelectPaymentMethod"}
										margin={"20px 0px 20px 0px" }
										handleInputClick={() => {
											props.handleCloseSelectCardAnonimous()
										}}
										handleBannerClick={(evt,bannerImageURL) => {
											console.log("CLICK BANNER SELECCIONA METODO PAGO 1",evt,bannerImageURL)
											const { executeTaggeo } = props;
											executeTaggeo({
												eventName: "pay_service_or_tae",
												step: "Formulario de pago",
												action: "Click banner",
												banner_id: bannerImageURL,
												id_message: "Elige método de pago"
											});
										}}
										serviceId={props.serviceId}
			
									/>
								:
									// Option 1 - Claro pay
									<div 
										role="button"
										tabIndex={0}
										aria-label="Seleccionar pagar con Claro Pay Inbursa"
										style={{
											backgroundColor: "#ffffff",
											borderRadius: "4px",
											boxShadow: "0px 2px 4px 0px #fafafa, 0px 2px 2px 0px #b6b6b6",
											marginBottom: "25.4px",
											padding: "0px",
											height: "57.6px",
											display: "flex",
											zIndex: "1"
										}}
										onClick={() => {
											if(props.canMultiAnalytics && props.isContainerTelcel) {
												const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
												console.log(originAnalyticArray, props, "ORigine");
												props.executeTaggeo({
														eventName: "pay_service_or_tae",
														seccion: "servicios",
														subseccion: getServicesTelcel(props.serviceInfo.serviceId),
														origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
														pantalla: "formulario de pago",
														nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ,
														tipoElemento: "card",
														nombreElemento: "cuenta n2",
														tagTipoElemento: "modal",
														trackAction: true,
														isTelcel: true
												}, true);
											} 
											props.setAddCardFormData({ ...props.addCardFormData, paymentMethodSelected: "claro-pay" })
										}}>
										<div style={{
											padding: "0px 16px 0px 16px",
											display: "flex",
											alignItems: "center",
											height: "57.6px",
											width: "100%"
										}}>
											<img
												src={ imgClaroPay }
												style={{ maxWidth: "100%" }} 
												alt='' />
										</div>
										{
											props.isContainerTelcel &&
												<div style={{
													width: "12%",
													alignContent: "center",
												}}>
													<img
														src={ "/images/arrow-up.png" }
														/>
												</div>
										}
									</div>
						}
			
						{/* Option 2 - Credit card */}
						<div style={{
							backgroundColor: "#ffffff",
							borderRadius: "4px",
							boxShadow: "0px 2px 4px 0px #fafafa, 0px 2px 2px 0px #b6b6b6",
							marginBottom: "57.4px",
							padding: "0px",
							height: "57.6px",
							display: "flex",
							zIndex: "1"
						}}
						role="button"
						tabIndex={0}
						aria-label="Seleccionar pagar con tarjeta visa master card"
						onClick={() => {
							if(props.canMultiAnalytics && props.isContainerTelcel) {
								const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
								props.executeTaggeo({
										eventName: "pay_service_or_tae",
										seccion: "servicios",
										subseccion: getServicesTelcel(props.serviceInfo.serviceId),
										origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
										pantalla: "formulario de pago",
										nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ,
										tipoElemento: "card",
										tagTipoElemento: "modal",
										nombreElemento: "tarjeta",
										trackAction: true,
										isTelcel: true
								}, true);
							} 
							if(props.tokenizationOn){
								props.setAddCardForm({ ...props.addCardFormData, paymentMethodSelected: "credit-card" });
							} else {
								props.setAddCardFormData({ ...props.addCardFormData, paymentMethodSelected: "credit-card" });
							}
						}}>
							<div style={{
								padding: "0px 16px 0px 16px",
								display: "flex",
								alignItems: "center",
								height: "57.6px",
								width: "100%"
							}}>
								<img
									src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}gr_fico_visa_y_mastercard.png`}
									style={{ maxWidth: "100%" }} 
									alt='' />
								
							</div>
							{
								props.isContainerTelcel &&
									<div style={{
										width: "12%",
										alignContent: "center",
									}}>
										<img
											src={ "/images/arrow-up.png" }
											/>
									</div>
							}
						</div>
					</div>
					:
					<></>
			}
		</>		
	)
}

const mapStateToProps = (state) => {
    const { payments } = state;
	const msisdn = payments.PAYMENT_SERVICE_CONF.msisdn;
	const addCardFormData = payments.addCardFormData;
	const isAnonimous = payments.isAnonimous;
	const isContainerTelcel = payments.isContainerTelcel;
	const canR1 = payments.canR1;
	const originAnalytic = getOriginParamsSelector(state);
    return {
        msisdn,
		addCardFormData,
		isAnonimous,
		isContainerTelcel,
		tokenizationOn: getTokenizationOnSelector(state),
		canMultiAnalytics: getCanMultiAnalytics(state),
		originAnalytic,
		canR1
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setAddCardFormData,
			executeTaggeo,
			setUnificationFlow,
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethodsList)